import { Link } from 'react-router-dom'
import { client } from '../../hooks/Client'
import useAddressMatches from '../../hooks/useAddressMatches'

// Bovenaan Huishoudens: er wachten invullingen op een keuze. Nodig omdat de
// kaart 'Adressen om te koppelen' alleen op het dashboard staat (en daar niet
// vanzelf); wie het nieuwe huishouden in deze lijst zocht, zag niets
// (testronde 2026-10-12, B5).
//
// Geen eigen foutmelding: een leesfout staat al op de dashboardkaart, en
// hier zou 'niets' dan beweren dat er niets wacht — dus bij een fout zwijgt
// deze melding in plaats van iets te beweren.
// AI-CONTEXT: See docs/features/adres-koppeling-algemene-qr.md

const AddressMatchesNotice = () => {
    const { matches, loaded, error } = useAddressMatches()
    if (!loaded || error || matches.length === 0) return null

    const count = matches.length
    return (
        <p className='measurement-signal-note' role='status'>
            {count === 1 ? 'Er wacht 1 adres op een keuze.' : `Er wachten ${count} adressen op een keuze.`}
            {' Kies op het '}<Link to={`/${client}/`}>dashboard</Link>{", op de kaart 'Adressen om te koppelen'."}
        </p>
    )
}

export default AddressMatchesNotice
